import service from '@/service'
import urlManager from '@/urlManager'
import { MILLIS_IN_A_DAY } from '@/utils/formatDate'
import safeJSONParse from '@/utils/safeJSONParse'
import { STORAGE_KEYS } from '../../constants/storage'

const SNOOZE_TIMEOUT = MILLIS_IN_A_DAY

/**
 * This is the store module for announcements that user get on launch of the application
 */
export default {
  namespaced: true,
  state: () => {
    let announcement = safeJSONParse(localStorage.getItem(STORAGE_KEYS.announcement)) || {}
    let lastReadDate =
      announcement.newestAnnouncementReadDate ||
      localStorage.getItem(STORAGE_KEYS.newestAnnouncementReadDate)
    let lastSnoozedAt = announcement.lastSnoozedAt
    if (isNaN(Date.parse(lastReadDate))) {
      lastReadDate = null
    }
    if (isNaN(Date.parse(lastSnoozedAt))) {
      lastSnoozedAt = null
    }
    return {
      newAnnouncements: [],
      newestAnnouncementReadDate: lastReadDate,
      lastSnoozedAt
    }
  },
  getters: {
    hasNewAnnouncements: state => state.newAnnouncements.length > 0
  },
  mutations: {
    SET_NEW_ANNOUNCEMENTS(state, announcements) {
      state.newAnnouncements = announcements
    },
    READ_NEWEST_ANNOUNCEMENT(state) {
      const newest = state.newAnnouncements.length > 0 ? state.newAnnouncements[0] : null
      state.newestAnnouncementReadDate = newest.createdAt
      const announcement = safeJSONParse(localStorage.getItem(STORAGE_KEYS.announcement)) || {}
      localStorage.setItem(
        STORAGE_KEYS.announcement,
        JSON.stringify({
          ...announcement,
          newestAnnouncementReadDate: newest.createdAt
        })
      )
      state.newAnnouncements = []
    },
    SNOOZE_ANNOUNCEMENT(state) {
      const announcement = safeJSONParse(localStorage.getItem(STORAGE_KEYS.announcement)) || {}
      localStorage.setItem(
        STORAGE_KEYS.announcement,
        JSON.stringify({
          ...announcement,
          lastSnoozedAt: new Date().toISOString()
        })
      )
      state.newAnnouncements = []
    }
  },
  actions: {
    async getNewAnnouncements({ state, commit }) {
      let response = await service.client.get(urlManager.announcements, {
        params: { created_after: state.newestAnnouncementReadDate }
      })
      const announcementSettings =
        safeJSONParse(localStorage.getItem(STORAGE_KEYS.announcement)) || {}
      let announcements = response.data
      let lastSnoozedAt = Date.parse(announcementSettings.lastSnoozedAt)
      if (lastSnoozedAt && Date.now() - lastSnoozedAt < SNOOZE_TIMEOUT) {
        announcements = announcements.filter(
          announcement => Date.parse(announcement.createdAt) > lastSnoozedAt
        )
      }
      commit('SET_NEW_ANNOUNCEMENTS', announcements)
      return response.data
    },
    readNewestAnnouncement({ commit }) {
      commit('READ_NEWEST_ANNOUNCEMENT')
    },
    snoozeAnnouncement({ commit }) {
      commit('SNOOZE_ANNOUNCEMENT')
    }
  }
}
